export type BookingStatus = 'confirmed' | 'pending' | 'cancelled';
export type BookingFilter = 'all' | 'upcoming' | 'past' | 'cancelled';
export type DateFilter = 'upcoming' | 'past' | 'all';
export type SortOrder = 'asc' | 'desc';

export interface BookingWithExperience {
  id: string;
  user_id: string;
  status: BookingStatus;
  created_at: string;
  total_amount: number;
  participant_count?: number;
  experience?: any;
}

export interface BookingFilters {
  status?: BookingStatus | BookingStatus[];
  dateFilter?: DateFilter;
  limit?: number;
  sortOrder?: SortOrder;
}

// Single flexible function to handle all booking filtering needs
export const getBookings = (bookings: BookingWithExperience[], filters: BookingFilters = {}) => {
  const {
    status,
    dateFilter = 'all',
    limit,
    sortOrder = 'desc'
  } = filters;

  let filtered = [...bookings];

  // Filter by status
  if (status) {
    const statusArray = Array.isArray(status) ? status : [status];
    filtered = filtered.filter(booking => statusArray.includes(booking.status));
  }

  // Filter by date
  if (dateFilter !== 'all') {
    const now = new Date();
    filtered = filtered.filter(booking => {
      const bookingDate = new Date(booking.created_at);
      return dateFilter === 'upcoming' ? bookingDate > now : bookingDate < now;
    });
  }

  // Sort by created_at
  filtered.sort((a, b) => {
    const dateA = new Date(a.created_at).getTime();
    const dateB = new Date(b.created_at).getTime();
    return sortOrder === 'desc' ? dateB - dateA : dateA - dateB;
  });

  // Apply limit
  if (limit) {
    filtered = filtered.slice(0, limit);
  }

  return filtered;
}; 